<template>
  <!-- Pace/health pill for an initiative's trajectory. Tint + hex come from trajectoryBadge; the glyph
       carries the state. Renders nothing when there's no trajectory. -->
  <span
    v-if="badge"
    class="inline-flex items-center gap-1 uppercase tracking-wide font-semibold rounded-full"
    :class="sizeClass"
    :style="{ background: badge.tint, color: badge.hex }"
  >
    <font-awesome-icon :icon="['fas', badge.icon]" />{{ badge.label }}
  </span>
</template>

<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faArrowTrendUp, faArrowTrendDown, faArrowRight, faShuffle } from "@fortawesome/free-solid-svg-icons";
import { trajectoryBadge } from "@/components/EngagementTracker/engagementTrackerHelpers.js";

library.add(faArrowTrendUp, faArrowTrendDown, faArrowRight, faShuffle);

export default {
  name: "ET_TrajectoryBadge",
  components: { FontAwesomeIcon },
  props: {
    trajectory: { type: String, default: null },
    // sm — tight contexts (Story card / hover); md — everywhere else.
    size: { type: String, default: "md" },
  },
  computed: {
    badge() {
      return trajectoryBadge(this.trajectory);
    },
    sizeClass() {
      return this.size === "sm" ? "text-[9px] px-1.5 py-0.5" : "text-[10px] px-2 py-0.5";
    },
  },
};
</script>
